import { useEffect, useState } from "react";
import {
  ElaborationStatus,
  ElaborationStatusItem,
  selectElaborationStatusList,
} from "../../redux/feature/object/remote-elaborations-slice";
import { useAppSelector } from "../../redux/hooks/hooks";

export interface UseFilteredElaborationsProps {
  findFunction: (item: FindItem) => boolean;
}

export type FindItem = ElaborationStatusItem & { elaboration: Omit<ElaborationStatus, "items"> };

export const useFilteredElaborations = (props: UseFilteredElaborationsProps) => {
  const elaborations = useAppSelector(selectElaborationStatusList);

  const [elaborationItems, setElaborationItems] = useState<ElaborationStatusItem[] | undefined>();

  useEffect(() => {
    const allItems: ElaborationStatusItem[] = elaborations
      ?.flatMap((e) => e.items.map((i) => ({ ...i, elaboration: e })))
      .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

    const elaborationItems: ElaborationStatusItem[] = allItems?.filter(props.findFunction);

    setElaborationItems(elaborationItems);
  }, [elaborations, props.findFunction]);

  return elaborationItems?.[0];
};
